import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'

export const StyledSkeleton = styled(Skeleton)`
    border-radius: 10px;
    height: 300px;
    width: 250px;
`